import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Lock, LogIn } from 'lucide-react';
// import { supabase } from '../lib/supabase';
// import toast from 'react-hot-toast';
import ImagesDev from '../api/images';
import { checkLoginStatus, loginUser } from '../api/authService';
import { Toast, ToastContainer } from '../components/Toast';
import Link from '../components/Link';

const supabase = []

export default function Login() {
    const [isLoading, setIsLoading] = useState(false);
    const [bgImage, setBgImage] = useState("");
    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });

    useEffect(() => {
        setBgImage(getRandomHeroImage())
    }, [])

    useEffect(() => {
        const verifyUser = async () => {
            const isAuthenticated = await checkLoginStatus();
            if (isAuthenticated) {
                window.location.href = "/profile"; // Redirect if not logged in
            }
        };
        verifyUser();
    }, []);

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await loginUser(formData.username, formData.password);

            if (!response.success) {
                Toast.error(JSON.stringify(response.message));
            } else {
                Toast.success('Welcome back!');
            }
        } catch (error) {
            Toast.error(JSON.stringify(error));
            // toast.error(error || 'Failed to sign in');
        } finally {
            setIsLoading(false);
        }
    };

    const getRandomHeroImage = () => {
        const images = window.innerWidth > 768 ? ImagesDev.heroImagesDesk : ImagesDev.heroImages;
        return images[Math.floor(Math.random() * images.length)];
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24"
        >
            <motion.img
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.4 }}
                transition={{ duration: 2 }}
                className='absolute top-0 left-0 h-full w-full'
                src={bgImage}
                style={{ objectFit: "cover" }}
            />
            <div className="container mx-auto px-4">
                <div className="max-w-md mx-auto pt-10">
                    <motion.div
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10"
                    >
                        <div className="text-center mb-8">
                            <h1 className="text-3xl font-bold mb-2">Welcome Back</h1>
                            <p className="text-gray-400">Sign in to your account</p>
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label className="block text-sm font-medium mb-2">User Name</label>
                                <div className="relative">
                                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                    <input
                                        type="text"
                                        name="username"
                                        value={formData.username}
                                        onChange={handleChange}
                                        className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300"
                                        required
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium mb-2">Password</label>
                                <div className="relative">
                                    <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                    <input
                                        type="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300"
                                        required
                                    />
                                </div>
                            </div>

                            <motion.button
                                type="submit"
                                disabled={isLoading}
                                className="w-full py-3 bg-gradient-to-r from-tc-gold to-orange-600 text-white rounded-lg hover:from-tc-gold hover:to-orange-700 transition-all duration-300 flex items-center justify-center space-x-2"
                                whileHover={{ scale: 1.02 }}
                                whileTap={{ scale: 0.98 }}
                            >
                                <LogIn className="w-5 h-5" />
                                <span>{isLoading ? 'Signing in...' : 'Sign In'}</span>
                            </motion.button>
                        </form>

                        <div className="mt-6 text-center">
                            <p className="text-gray-400">
                                Don't have an account?{' '}
                                <Link
                                    to="/register"
                                    className="text-orange-400 hover:text-orange-300 transition-colors"
                                >
                                    Sign up
                                </Link>
                            </p>
                        </div>
                    </motion.div>
                </div>
            </div>
        </motion.div>
    );
}